<!--  -->
<template>
  <div class="shownew">
     <el-carousel :interval="5000" arrow="never" height="634px">
        <el-carousel-item  v-for="(article,index) in articles" :key="index" :style="`background-image: url('${global.remoteIp}/uploads/${article.picsrc}');background-repeat: no-repeat;background-size: 100% 634px;background-position: center;`">
          <div style="width: 1200px;margin:393px auto 0;">
            <router-link :to="`/views/info/${article.plateid}/${article._id}`" class="animated bisylms-btn-3">查看详情</router-link>
          </div>
        </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data () {
    return {
        articles:[],
        global
    };
  },
  props: {
    plates:Array
  },
  mounted() {
    let strplate = "";
    for (var i = 0; i < this.plates.length; i++) {
        if(this.plates[i].name=="新闻动态"){
            strplate = this.plates[i]._id;
        }
    }
    this.$axios.get(`/api/articles?plateid=${strplate}&page=1&limit=3&sort=-createdAt`).then(res => {
        if(res.data)
        {
            this.articles=res.data.data;
            this.$nextTick(function(){
                this.installOwlCarousel()
            })
        }
    });
  },
  methods: {
      installOwlCarousel(){
          $('.homepage-slide1').owlCarousel({
            margin: 0,
            responsiveClass: true,
            dots: false,
            animateOut: 'fadeOut',
            autoplayTimeout: 4500,
            autoplay: true,
            smartSpeed: 800,
            center: true,
            items: 1
        });
      }
  }
}
</script>
<style scoped>
/deep/ .el-carousel__item--card.is-active{
    background-repeat: no-repeat;
    background-size: 100% 634px;
    background-position: center;
    width: 100%;
}

/deep/ .el-carousel__indicators--outside{
  display:none;
}
/deep/ .el-carousel__indicators--horizontal{
  display:none;
}
.shownew{
  width: 100% !important;
}
/deep/  .el-carousel__item a {
  display: inline-block;
width: 215px;
height: 65px;
background: #4462CF;
border-radius: 10px;
font-size: 24px;
font-family: PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 65px;
text-align: center;
  }
</style>